export default "__VITE_ASSET__CcNoz6Bu__"